// import RepositoryFactory from "@/apis";
// const AboutUs = RepositoryFactory.aboutUs;
import AboutUs from "../../apis/aboutUs";

export default {
  createAboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.createAboutUs(payload);
        // commit("CREATE_ABOUTUS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.getAboutUs(payload);

        commit("GET_ABOUTUS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteAboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.deleteAboutUs(payload);
        // commit("DELETE_ABOUTUS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editAboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.editAboutUs(payload);
        // commit("EDIT_ABOUTUS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
